import Service, {IService} from "@/model/Service/Service"
import hasTotalPrice, {IHasTotalPrice} from "@/model/mixins/Price/hasTotalPrice"
import hasCrossPrice, {IHasCrossPrice} from "@/model/mixins/Price/hasCrossPrice"



class GlobalServiceBase extends Service {
    private selected: boolean
    private included: boolean
    constructor(
        selected: boolean,
        included: boolean,
        id: string,
        quantity?: number,
        startDate?: string,
        endDate?: string,
    ) {
        super(
            id,
            quantity,
            startDate,
            endDate,
        )
        this.selected = selected
        this.included = included
    }

    public getSelected(): boolean {
        return this.selected
    }
    public getInlcuded(): boolean {
        return this.included
    }

}

export interface IGlobalService extends IService, IHasCrossPrice, IHasTotalPrice {
    getSelected(): boolean
    getInlcuded(): boolean
}


const GlobalService: Constructor<IGlobalService> = hasTotalPrice(hasCrossPrice(GlobalServiceBase))

export default GlobalService